import Immutable from 'seamless-immutable';
import _ from 'lodash';
import AdobeAttributesModel from './adobe-attributes-model';

/**
 * Transforms an array of backend adobe attributes into front end adobe attributes
 * @param {Object[]} AdobeAttribute - backend formatted adobe attributes
 * @returns {AdobeSource[]}
 */
function deserialize(dropdownData = []) {
  return Immutable(_.map(dropdownData, AdobeAttributesModel.deserialize));
}

export default {
  deserialize,
};
